import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-500 text-white pt-12 pb-6 relative">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo & Info */}
          <div>
            <img
              src="/assets/dist/img/AdminLTELogo.png"
              alt="SSKRU Logo"
              className="w-20 mb-4"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/80x80?text=SSKRU";
              }}
            />
            <p className="text-gray-200">
              งานบริการวิชาการ
              <br />
              สำนักส่งเสริมวิชาการและจัดการเรียนรู้ตลอดชีวิต
              <br />
              มหาวิทยาลัยราชภัฏศรีสะเกษ
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h5 className="text-white-500 text-lg font-semibold mb-4 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-12 after:h-0.5 after:bg-secondary-500">
              ติดต่อเรา
            </h5>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="fas fa-map-marker-alt text-white-500 mt-1"></i>
                <span className="text-gray-200">
                  อาคารพัชรกิติยาภา (ตึก7) มหาวิทยาลัยราชภัฏศรีสะเกษ
                </span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fas fa-envelope text-white-500"></i>
                <a
                  href="mailto:lifelong@sskru.ac.th"
                  className="text-gray-200 hover:text-white-500 transition-colors  hover:underline"
                >
                  lifelong@sskru.ac.th
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="fas fa-phone text-white-500"></i>
                <a
                  href="tel:045-564-362-2"
                  className="text-gray-200 hover:text-white-500 transition-colors  hover:underline"
                >
                  045-564-362-2
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h5 className="text-white-500 text-lg font-semibold mb-4 relative pb-2 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-12 after:h-0.5 after:bg-secondary-500">
              ติดตามเรา
            </h5>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/profile.php?id=100067890830799"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white text-primary-500 rounded-full flex items-center justify-center hover:bg-blue-500 hover:text-white transition-all hover:-translate-y-1"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.youtube.com/@SSKRU-knowledge"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white text-primary-500 rounded-full flex items-center justify-center hover:bg-red-600 hover:text-white transition-all hover:-translate-y-1"
              >
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>

        <hr className="border-gray-400 my-6" />

        <div className="text-center text-gray-300 text-sm">
          <p>
            Copyright © {currentYear} | Powered by{" "}
            <Link to="/" className="text-white-500 hover:underline">
              งานบริการวิชาการ สำนักส่งเสริมวิชาการและจัดการเรียนรู้ตลอดชีวิต
              มหาวิทยาลัยราชภัฏศรีสะเกษ
            </Link>
          </p>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="fixed bottom-6 right-6 w-12 h-12 bg-secondary-500 text-primary-500 rounded-full shadow-lg hover:bg-yellow-400 transition-all hover:-translate-y-1 z-50 flex items-center justify-center"
      >
        <i className="fas fa-arrow-up"></i>
      </button>
    </footer>
  );
};

export default Footer;
